module.exports = __webpack_public_path__ + "img/ufcw-charity-foundation.572c87b5.svg";